import React from "react";
import Swal from "sweetalert2";

export const BODY_PLACEHOLDER = `{
  "serviceId": "{serviceID}",
  "px_thID": "{clickID}"
}`;

const fieldStyle = {
  width: "100%",
  marginTop: "10px",
  border: "2px solid #e3f2fd",
  borderRadius: "10px",
  padding: "12px 16px",
  fontSize: "14px",
  color: "#1a237e",
  background: "#ffffff",
};

// Turns form state into the API payload; returns null (after alerting) if the POST body isn't valid JSON
export const buildPostbackPayload = (formData) => {
  if (formData.postbackMethod !== "POST") {
    return { ...formData, postbackBody: null };
  }

  try {
    const postbackBody = JSON.parse(formData.postbackBody);
    if (!postbackBody || typeof postbackBody !== "object" || Array.isArray(postbackBody)) {
      throw new Error("Body must be a JSON object");
    }
    return { ...formData, postbackBody };
  } catch (error) {
    Swal.fire({
      title: "Invalid postback body",
      text: `The POST body must be a valid JSON object. ${error.message}`,
      icon: "error",
    });
    return null;
  }
};

export const bodyToString = (body) => (body ? JSON.stringify(body, null, 2) : "");

const PostbackFields = ({ formData, onChange, Wrapper }) => (
  <>
    <Wrapper className="full-width">
      <label htmlFor="postbackMethod">Postback method</label>
      <select
        id="postbackMethod"
        name="postbackMethod"
        value={formData.postbackMethod}
        onChange={onChange}
        style={fieldStyle}
      >
        <option value="GET">GET</option>
        <option value="POST">POST (JSON body)</option>
      </select>
    </Wrapper>

    {formData.postbackMethod === "POST" && (
      <Wrapper className="full-width">
        <label htmlFor="postbackBody">Postback body (JSON)</label>
        <p>
          Sent to the postback url as JSON. Use {"{clickID}"}, {"{sourceID}"} and{" "}
          {"{serviceID}"} (the campaign's Service ID) in any value.
        </p>
        <textarea
          id="postbackBody"
          name="postbackBody"
          rows={10}
          placeholder={BODY_PLACEHOLDER}
          value={formData.postbackBody}
          onChange={onChange}
          required
          style={{ ...fieldStyle, fontFamily: "monospace", resize: "vertical" }}
        />
      </Wrapper>
    )}
  </>
);

export default PostbackFields;
